import { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";

import {
	API_URL,
	scroll,
	createMarkup,
	isFieldError,
	getValFromLS,
} from "../helpers";

import Hdg from "../components/Hdg";
import Alert from "../components/Alert";
import Input from "../components/Input";
import Select from "../components/Select";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

import Nav from "./Nav";

const Tr = ({ data, remove, resend }) => {
	return (
		<tr>
			<td>
				{data.event === "sporting"
					? "Sporting Clays"
					: data.event === "welcome"
					? "Welcome Party"
					: data.event === "gift"
					? "Gift Package"
					: "Golf"}
			</td>
			<td
				className={
					data.status === 1
						? "left success"
						: data.status === 0
						? "left error"
						: data.status === 4
						? "left notice"
						: "left working"
				}
			>
				<div className="flex">
					<i
						className={
							data.status === 1
								? "fa fa-check-circle"
								: data.status === 0
								? "fa fa-times-circle"
								: data.status === 2
								? "fa fa-hourglass-o"
								: data.status === 4
								? "fa fa-clock-o"
								: "fa fa-info-circle"
						}
					/>
					<span>{data.text}</span>
				</div>
			</td>
			<td>
				{(data.status === 1 || data.status === 2) && (
					<button
						type="button"
						className="naked"
						title="Remove from spot"
						onClick={(e) => remove(e, data.id, data.event)}
					>
						<i className="fa fa-trash error fa-lg" />
					</button>
				)}
			</td>
		</tr>
	);
};

const Guest = () => {
	const [user, setUser] = useState({});
	const [details, setDetails] = useState({});
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({});
	const [msg, setMsg] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const { str } = useParams();
	const formElement = useRef(null);

	useEffect(() => {
		const init = async () => {
			/*
        const auth = getValFromLS("dash", true)
          ? JSON.parse(getValFromLS("dash", true))
          : {};
      */
			const url = new URL(`${API_URL}/dashboardGuestInit`);
			const params = {
				q: str ? str : "",
			};
			url.search = new URLSearchParams(params);

			try {
				const response = await fetch(url, {
					method: "GET",
					cache: "no-store",
				});
				const json = await response.json();
				if (json && json.resp === 1) {
					setUser({ ...JSON.parse(getValFromLS("dash", true)) });
					setDetails({ ...json });
					setAlert({});
					scroll();
				} else {
					setAlert({
						type: json.resp === 2 ? "notice" : "error",
						text: json.text,
					});
				}
			} catch (error) {
				setAlert({
					type: "error",
					text: "An error has occurred.",
				});
			}
		};

		init();

		// eslint-disable-next-line
	}, []);

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/dashboardGuestResend`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			data.append(key, value);
		});
		data.append("q", details.id);
		data.append("auth", getValFromLS("dash", true));
		data.append("fromAdmin", getValFromLS("vtoUserToken") ? "1" : "0");

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setNames({});
				formElement.current.recipient.selectedIndex = 0;
				setMsg({
					type: "success",
					text: json.text,
				});
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	const handleRemove = async (e, id, event) => {
		e.preventDefault();

		const url = new URL(`${API_URL}/dashboardGuestRemove`);
		let data = new FormData();
		data.append("q", id);
		data.append("event", event);
		data.append("auth", getValFromLS("dash", true));
		data.append("fromAdmin", getValFromLS("vtoUserToken") ? "1" : "0");

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setDetails({ ...json });
			} else {
			}
		} catch (error) {}
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div id="left-column">
						<Hdg section="Sponsor Dashboard" />
						<p>
							Use this page to view your guest information and manage invitation
							statuses.
						</p>

						<div className="spacer"></div>

						<table className="approved">
							<thead>
								<tr>
									<th>Name</th>
									<th>Email</th>
									<th>Phone</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td className="center">{details.name}</td>
									<td className="center">
										<a href={`mailto:${details.email}`}>{details.email}</a>
									</td>
									<td className="center">{details.phone}</td>
								</tr>
							</tbody>
						</table>

						<table className="approved assigned">
							<thead>
								<tr>
									<th colSpan="3" className="hdg">
										Invitation Status
									</th>
								</tr>
								<tr>
									<td>Event</td>
									<td className="left">Status</td>
									<td>Remove</td>
								</tr>
							</thead>

							<tbody>
								<Tr
									data={{
										...details.invite.golf,
										event: "golf",
										id: details.id,
									}}
									remove={handleRemove}
								/>
								<Tr
									data={{
										...details.invite.sporting,
										event: "sporting",
										id: details.id,
									}}
									remove={handleRemove}
								/>
								<Tr
									data={{
										...details.invite.welcome,
										event: "welcome",
										id: details.id,
									}}
									remove={handleRemove}
								/>
								<Tr
									data={{
										...details.invite.gift,
										event: "gift",
										id: details.id,
									}}
									remove={handleRemove}
								/>
							</tbody>
						</table>
						{/*(details.invite.golf.status === 2 ||
              details.invite.sporting.status === 2 ||
              details.invite.welcome.status === 2 ||
              details.invite.gift.status === 2) && (*/}
						<form
							ref={formElement}
							method="post"
							action="/"
							onSubmit={(e) => handleSubmit(e)}
							className="well"
							style={{ marginTop: "25px" }}
						>
							<h4
								style={{
									marginTop: "0",
									lineHeight: "22px",
									marginBottom: "10px",
									fontSize: "1.1rem",
								}}
							>
								Resend Registration Access Link
							</h4>

							<div className="form-group">
								<Select
									name="recipient"
									label="Select Recipient"
									reqd={true}
									value={names.recipient || ""}
									options={[
										{ id: "", name: "--" },
										{
											id: `${details.email}`,
											name: `Original Recipient (${details.email})`,
										},
										{ id: "other", name: "Another Recipient" },
									]}
									update={handleUpdate}
									error={isFieldError(errors, "recipient")}
								/>

								{names.recipient === "other" ? (
									<Input
										name="email"
										label="Enter Other Email"
										reqd={true}
										value={names.email || ""}
										update={handleUpdate}
										errors={errors}
									/>
								) : (
									<div className="empty" />
								)}
							</div>

							<div className="msg-submit">
								{msg.type && <Msg data={msg} />}

								<div
									className={
										msg.type === "working" ? "hidden" : "submit-container"
									}
								>
									<Submit submit="Resend Invitation" />
								</div>
							</div>
						</form>

						<table className="approved assigned">
							<thead>
								<tr>
									<th colSpan="2" className="hdg">
										Guest Information
									</th>
								</tr>
							</thead>
							{details.values[0].value ? (
								<tbody>
									{details.values.map((item, index) => {
										return (
											<tr key={index}>
												<th className="right top" style={{ width: "25%" }}>
													{item.key}
												</th>
												<td
													className="left"
													dangerouslySetInnerHTML={createMarkup(item.value)}
												/>
											</tr>
										);
									})}

									{details.invite.golf.status === 1 &&
										details.invite.valuesGolf.map((item, index) => {
											return (
												<tr key={index + 100}>
													<th className="right top">{item.key}</th>
													<td
														className="left"
														dangerouslySetInnerHTML={createMarkup(item.value)}
													/>
												</tr>
											);
										})}

									{details.invite.sporting.status === 1 &&
										details.invite.valuesSporting.map((item, index) => {
											return (
												<tr key={index + 200}>
													<th className="right top">{item.key}</th>
													<td
														className="left"
														dangerouslySetInnerHTML={createMarkup(item.value)}
													/>
												</tr>
											);
										})}

									{details.invite.gift.status === 1 &&
										details.invite.valuesGift.map((item, index) => {
											return (
												<tr key={index + 300}>
													<th className="right top">{item.key}</th>
													<td
														className="left"
														dangerouslySetInnerHTML={createMarkup(item.value)}
													/>
												</tr>
											);
										})}
								</tbody>
							) : (
								<tbody>
									<tr>
										<td
											className="center"
											colSpan="2"
											style={{ paddingTop: "15px", paddingBottom: "15px" }}
										>
											<span className="working">
												-- Details not yet submitted --
											</span>
										</td>
									</tr>
								</tbody>
							)}
						</table>

						<div className="spacer"></div>
					</div>

					<div id="right-column">
						<Nav on={0} user={user} />
					</div>
				</>
			)}
		</>
	);
};

export default Guest;
